import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  deSelectAllListings,
  fetchWorkHistory,
  setLoading,
  toggleCandidateWorkedFilter,
  updateWorkedHistoryFilters,
  updateWorkedHistoryPagination,
  reStateWorkHistroyFilters,
} from "@/reducers/clientcandidatedetail";

import ModalPopUp from "../../ModalPopUp";
import CalendarFilter from "../ListingFilters/CalendarFilter";
import DropDownFilter from "../ListingFilters/DropDownFilter";
import FilterModalBottomAction from "../ListingFilters/FilterModalBottomAction";
import { FilterModalTop } from "../ListingFilters/FilterModalTop";
import TextFieldFilter from "../ListingFilters/TextFieldFilter";

const WorkedFilterModal = () => {
  const {
    workedHistoryShowFiltersModal,
    workedHistoryFilters,
    workedHistoryPagination,
    candidateDetails,
    workedHistoryView,
  } = useSelector((state) => state.clientCandidateDetail);
  const { filterLists } = useSelector((state) => state.clientsCandidates);

  const dispatch = useDispatch();

  const handleClose = (fromBtn = false) => {
    if (fromBtn) {
      dispatch(reStateWorkHistroyFilters());
    }
    dispatch(toggleCandidateWorkedFilter(false));
  };

  const handleApply = () => {
    dispatch(setLoading(true));
    dispatch(
      updateWorkedHistoryPagination({
        ...workedHistoryPagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(deSelectAllListings());
    dispatch(fetchWorkHistory(workedHistoryFilters));
    handleClose();
  };

  const handleReset = () => {
    dispatch(updateWorkedHistoryFilters({}));
    dispatch(
      updateWorkedHistoryPagination({
        ...workedHistoryPagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(deSelectAllListings());
    dispatch(setLoading(true));
    dispatch(
      updateWorkedHistoryFilters({
        search: workedHistoryFilters.search,
      }),
    );
    dispatch(fetchWorkHistory({ candidate_id: candidateDetails.candidate_id }));
    handleClose();
  };

  return (
    <ModalPopUp
      show={workedHistoryShowFiltersModal}
      panelClass="max-w-[774px]"
      onClose={() => {
        handleClose(true);
      }}
    >
      <div className="grid gap-6">
        <div className="grid gap-[18px]">
          <div className="grix gap-4">
            <FilterModalTop
              handleClose={() => {
                handleClose(true);
              }}
            />
          </div>
          <div className="grid grid-cols-1 gap-x-6 gap-y-[18px] sm:grid-cols-2">
            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(
                  updateWorkedHistoryFilters({ contractReferenceNo: value }),
                );
              }}
              label="Contract Ref. No."
              value={workedHistoryFilters.contractReferenceNo}
              filterId="contractReferenceNo"
              placeholder="Enter Contract Ref. No."
            />
            {workedHistoryView === "shifts" ? (
              <DropDownFilter
                options={
                  filterLists && filterLists?.allUsers?.length > 0
                    ? filterLists?.allUsers
                    : []
                } // this is the list of roles
                id="Action By"
                label="Actioned By"
                // isMultiple="false"
                placeholder="Select Action by"
                value={workedHistoryFilters.actionedById} // selected role
                handleChange={(value, type) => {
                  dispatch(
                    updateWorkedHistoryFilters({
                      actionedById: value,
                      actionedByType: type,
                    }),
                  );
                }} // function to handle change of role
              />
            ) : null}
          </div>
          <div className="_filter_calendar">
            <CalendarFilter
              label="Shift Date (From - To)"
              dateFrom={workedHistoryFilters.contractDateFrom}
              dateTo={workedHistoryFilters.contractDateTo}
              handleChange={(value) => {
                dispatch(
                  updateWorkedHistoryFilters({
                    contractDateFrom: value.dateFrom,
                    contractDateTo: value.dateTo,
                  }),
                );
              }}
            />
          </div>
        </div>
        <FilterModalBottomAction
          applyFunc={handleApply}
          resetFunc={handleReset}
        />
      </div>
    </ModalPopUp>
  );
};

export default WorkedFilterModal;
